// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ReportIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M20.46 8.87h-3.2c-1.9 0-3.47-1.58-3.47-3.5v-3.4c0-.26-.2-.48-.47-.48H7.76c-2.59 0-4.69 2.13-4.69 4.74v11.31c0 2.73 2.2 4.95 4.91 4.95h8.27c2.59 0 4.67-2.11 4.67-4.72V9.34c0-.26-.2-.47-.46-.47"
        opacity=".5"
      />
      <path d="M17.4 7.34H20c.43 0 .66-.52.35-.84-.54-.58-1.3-1.38-2.08-2.18l-2.1-2.22c-.31-.32-.85-.1-.85.35v2.77c0 1.16.94 2.12 2.1 2.12m-2.75 4.97-3.81 3.8q-.25.25-.57.25t-.57-.24l-1.86-1.86c-.32-.32-.32-.83 0-1.14.31-.32.82-.32 1.14 0l1.29 1.29 3.24-3.24c.31-.32.82-.32 1.14 0 .31.31.31.82 0 1.14" />
    </g>
  </SvgIcon>
);

export default ReportIcon;
